// Mileage is a plain whole number, so anything that is not a digit is rejected as it is
// typed. inputMode only hints the mobile keyboard, it does not stop a desktop keyboard.
const disallowedCharacters = /\D/g;
// Mirrors the upper bound of the mileage field in the form schema.
export const maxMileageLength = 10;

export function sanitizeMileage(value: string): string {
  return value.replace(disallowedCharacters, '').slice(0, maxMileageLength);
}
